import React from 'react'
import { connect } from 'react-redux'

import styles from './loadingScreen.module.css'

function LoadingScreen({ isDarkMode }) {
    return (
        <div className={`${styles.PageBody} ${isDarkMode && styles.Dark}`}>
            <div className={styles.Hourglass} />
        </div>
    )
}

const mapSTP = state => ({
    isDarkMode: state.ui.isDarkMode
})

export default connect(mapSTP)(LoadingScreen)